var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('pt-page-title',{attrs:{"title":"创建订单"}}),_c('pt-order-form',{ref:"form",staticClass:"pt-order-form__withData",attrs:{"groupList":_vm.groupList,"customerLoading":_vm.loading},on:{"toSubmit":_vm.toSubmit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }